// extracted by mini-css-extract-plugin
export var phone = "_2r-0";
export var phoneDragging = "_2r-1";